module.exports = Blueprint.Popover2